export interface IHttpResponse<T> {
    statusCode: string | number;
    message: string;
    data: T[];
  }
  
  export interface IPageResult<T> {
    records: number;
    items: T[];
    pages: number;
    page: number;
  }
  
  export interface IAction<T> {
    type: string;
    payload: T;
  }
  
  export interface IPayloadNavigable {
    navigate: any;
    location: any;
  }
  
  export class HttpError {
    public code: string;
    public message: string;
  
    constructor(message: string, code: string) {
      this.message = message;
      this.code = code;
    }
  }
  
  export interface ICommonState {
    error: HttpError;
    loading: boolean;
  }
  